import { CSSProperties } from 'react';

import { Icon } from '@mui/material';

import { stl_gold_color_light } from 'theme/cemTheme';

import { classNames } from './utils';

export type FontAwesomeIconType =
  | 'solid'
  | 'regular'
  | 'light'
  | 'thin'
  | 'duotone'
  | 'brands'
  | 'sharp-solid'
  | 'sharp-regular'
  | 'sharp-light'
  | 'sharp-thin'
  | 'sharp-duotone'
  | 'duotone-regular'
  | 'duotone-solid';

export default function FontAwesomeIcon({
  name,
  type = 'solid',
  sx = {},
  classes = [],
  title,
  size = '1rem', // default - 16px
  gold = false,
}: {
  name: string;
  size?: string;
  type?: FontAwesomeIconType;
  sx?: CSSProperties;
  classes?: string[];
  title?: string;
  gold?: boolean;
}) {
  const faClasses = type.split('-').map((word) => `fa-${word}`);

  return (
    <Icon
      title={title}
      className={classNames(...faClasses, `fa-${name}`, ...classes)}
      sx={{
        '&.svg-inline--fa': {
          width: size,
          height: size,
          color: gold ? stl_gold_color_light : undefined,
          ...sx,
        },
      }}
    />
  );
}
